import React from 'react'
import { motion, AnimatePresence } from "framer-motion";
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';

export default function Faq() {

    const FAQ = [
        { question: "1. Is this a course?", answer: "No. It is a Students Skilling System focused on clarity and capability." },
        { question: "2. Who teaches?", answer: "Founders, developers, designers, and industry practitioners." },
        { question: "3. Is ₹499 final?", answer: "✅ Yes. One program. One price. No hidden fees." },
        { question: "4. Is the program online?", answer: "Yes. Live Zoom sessions." },
        { question: "5. Who can join?", answer: "Any degree, any year, any stream." },
        { question: "6. Do you provide certificates?", answer: "Certificates are optional. The focus is transformation." },
        { question: "7. Will this help placements?", answer: "Yes indirectly by building real capability and confidence." },
        { question: "8. Is English required?", answer: "No." },
    ];
    const [isFaq, setIsFaq] = React.useState(FAQ.map((_, index) => index === 0));

    const handleFaq = (index) => {
        const newIsFaq = isFaq.map((value, i) => i === index ? !value : false);
        setIsFaq(newIsFaq);
    };


    return (
        <div className='bg-[#F9FAFB] py-[20px] md:py-[50px] lg:py-[70px]'>
            <h4 className='text-[#101828] text-[24px] md:text-[32px] font-bold text-center'>Frequently Asked Questions</h4>
            <div className='mt-[20px] md:mt-[36px] flex flex-col gap-[16px] items-center justify-center'>
                {FAQ.map((each, index) => (
                    <div
                        key={index} className={`relative w-[316px] md:w-[636px] lg:w-[846px] min-h-[40px] md:min-h-[61px] border-[1px] rounded-[14px] ${isFaq[index] ? "border-[#27AE60]" : "border-[#AFAEAE]"}`}>
                        <div className="p-[10px] md:p-[20px] cursor-pointer" onClick={() => handleFaq(index)} >
                            <h1 className={`font-medium text-[14px] md:text-[16px] lg:text-[18px] ${isFaq[index] ? "text-[#27AE60]" : "text-[#6F6F6F]"}`} >{each.question} </h1>
                            {isFaq[index] ? (
                                <IoIosArrowUp className="absolute right-[5px] md:right-[20px] text-[14px] md:text-[16px] lg:text-[18px] top-[14px] md:top-[25px] fill-[#27AE60]" />
                            ) : (
                                <IoIosArrowDown className="absolute right-[5px] md:right-[20px] text-[14px] md:text-[16px] lg:text-[18px] top-[14px] md:top-[25px] fill-[#AFAEAE]" />
                            )}
                            <AnimatePresence>
                                {isFaq[index] && (
                                    <motion.div
                                        initial={{ height: 0, opacity: 0 }}
                                        animate={{ height: "auto", opacity: 1 }}
                                        exit={{ height: 0, opacity: 0 }}
                                        transition={{ duration: 0.3 }}
                                        className="overflow-hidden"
                                    >
                                        <h1 className="font-normal text-[12px] md:text-[14px] lg:text-[18px] text-[#6F6F6F] mt-[10px]">{each.answer}</h1>
                                        {each?.list1 && (
                                            <ul className='list-disc pl-5 marker:text-[#27AE60] font-normal text-[12px] md:text-[14px] lg:text-[18px] text-[#364153] mt-[5px]'>
                                                <li>{each?.list1}</li>
                                                {each?.list2 && (
                                                    <li>{each?.list2}</li>
                                                )}
                                                {each?.list3 && (
                                                    <li>{each?.list3}</li>
                                                )}
                                                {each?.list4 && (
                                                    <li>{each?.list4}</li>
                                                )}
                                                {each?.list5 && (
                                                    <li>{each?.list5}</li>
                                                )}
                                            </ul>
                                        )}
                                    </motion.div>
                                )}
                            </AnimatePresence>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}
